const getJsonAttribute = (el, key) => {
  try {
    return JSON.parse(el?.dataset?.[key]);
  } catch (e) {
    console.error(e);
    return {};
  }
};

export default getJsonAttribute;
